/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import get from 'lodash/get';
import { withNamespaces } from 'react-i18next';
import { Text, Link } from '@sitecore-jss/sitecore-jss-react';
import { Row, Column, MediaQueries } from '../../../../styles/Grid';
import { showElementCss } from '../../../../utils/responsive';
import { buttonReset } from '../Nav/index.styles';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import LinkWrapper from '../../../ui/LinkWrapper';
import {
  itemsContainerCss,
  itemTextCss,
  itemCss,
  buttonCss,
  titleCss,
  descriptionCss,
  activeItemCss,
  activeTextCss,
  bottomLinksCss,
  linkStyleCss,
  bottomRightLink1Css,
  verticalLineCss,
} from './index.styles';

const renderContent = (fields, t) => {
  const { Title, Description, FindOutMoreCta, id } = fields;
  FindOutMoreCta.value.text = t('FindOutMoreCTA');
  return (
    <React.Fragment key={`content-ways-${id}`}>
      <h2 css={titleCss}>
        <Text field={Title} />
      </h2>
      <p css={descriptionCss}>
        <Text field={Description} />
      </p>
      <Row>
        <Column cols={{ lg: [3, 6], xl: [2, 5] }}>
          <LinkWrapper field={FindOutMoreCta} />
        </Column>
      </Row>
    </React.Fragment>
  );
};

export const onClickNavigationItem = (event, waysToWorkItems) => {
  const { id } = event.target;
  const [itemFiltered] = waysToWorkItems.filter(
    item => id === get(item, 'fields.id', 0),
  );
  const url = get(itemFiltered, 'fields.FindOutMoreCta.value.href', '');
  window.open(url, '_self');
};

class WaysToWork extends SafePureComponent {
  state = {
    hoveredElement: get(
      this.props.fields,
      'NavigationItems.value[0].fields.id',
      0,
    ),
  };

  onInteractionItem = event => {
    const { id } = event.target;
    this.setState({ hoveredElement: id });
  };

  safeRender() {
    const { hoveredElement } = this.state;
    const { t } = this.props;
    const waysToWorkItems = get(this.props.fields, 'NavigationItems.value', {});
    const BottomRightLink1 = get(this.props.fields, 'BottomRightLink1', {});
    const BottomRightLink2 = get(this.props.fields, 'BottomRightLink2', {});

    return (
      <React.Fragment>
        <Column cols={{ sm: 6, md: 8, lg: 6, xl: 5 }} css={itemsContainerCss}>
          <ul>
            {waysToWorkItems.map((item, index) => {
              return (
                <li css={itemCss} key={item.fields.id}>
                  <button
                    css={[
                      buttonReset,
                      buttonCss,
                      hoveredElement === item.fields.id && activeItemCss,
                    ]}
                    id={item.fields.id}
                    onClick={event =>
                      onClickNavigationItem(event, waysToWorkItems)
                    }
                    onMouseOver={this.onInteractionItem}
                    onFocus={this.onInteractionItem}
                    aria-label={item.fields.Label.value}
                  >
                    <p
                      css={[
                        itemTextCss,
                        hoveredElement === item.fields.id && activeTextCss,
                      ]}
                      key={index}
                    >
                      {item.fields.Label.value}
                    </p>
                  </button>
                </li>
              );
            })}
          </ul>
        </Column>
        <Column
          css={[itemsContainerCss, showElementCss(MediaQueries.lgAndUp)]}
          cols={{ lg: 6, xl: 5 }}
        >
          {waysToWorkItems.map(item => {
            if (item.fields.id !== hoveredElement) return null;
            return renderContent(item.fields, t);
          })}
        </Column>
        <div css={bottomLinksCss}>
          <Link
            field={BottomRightLink1}
            css={[linkStyleCss, bottomRightLink1Css]}
          />
          <Link field={BottomRightLink2} css={linkStyleCss} />
        </div>
        <span css={[verticalLineCss, showElementCss(MediaQueries.xl)]} />
      </React.Fragment>
    );
  }
}

WaysToWork.displayName = 'NavBar/WaysToWork';

WaysToWork.defaultProps = {
  t: key => key,
};

export default withNamespaces()(WaysToWork);
